import { TInquiriesDetailsData } from "@/interfaces";

const CompanyOwnersInquiryDetails = ({
  data,
}: {
  data: TInquiriesDetailsData;
}) => {
  return <div>CompanyOwnersInquiryDetails</div>;
};

export default CompanyOwnersInquiryDetails;
